/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum B2cUserAttribute {
    AccountEnabled = 'AccountEnabled',
    CreatedDateTime = 'CreatedDateTime',
    DisplayName = 'DisplayName',
    EmailAddress = 'EmailAddress',
    GivenName = 'GivenName',
    Id = 'Id',
    Identities = 'Identities',
    OneAirAdminRole = 'OneAirAdminRole',
    Surname = 'Surname'
}

export function B2cUserAttributeFromJSON(json: any): B2cUserAttribute {
    return B2cUserAttributeFromJSONTyped(json, false);
}

export function B2cUserAttributeFromJSONTyped(json: any, ignoreDiscriminator: boolean): B2cUserAttribute {
    return json as B2cUserAttribute;
}

export function B2cUserAttributeToJSON(value?: B2cUserAttribute | null): any {
    return value as any;
}

